import * as pluralize from 'pluralize';
import { Observable } from 'rxjs/internal/Observable';
import { map } from 'rxjs/operators';
import { BaseApiClient } from '../base-api-client';
import { HttpResponse } from '@angular/common/http';

export function WhiteList<T>() {

    return function (target) {

        const whiteList = function (id: string): Observable<T> {
            return this.toggleWhiteBlackList(id, false);
        };

        const blackList = function (id: string): Observable<T> {
            return this.toggleWhiteBlackList(id, true);
        };

        const toggleWhiteBlackList = function (id: string, blacklist: boolean): Observable<T> {
            if (!(this instanceof BaseApiClient)) {
                throw new Error('Decorated element must by type BaseApiClient');
            }
            let options = this.prepareRequestOptionsForDecorators();

            return this.http
                .patch(`${this.apiBase()}/${id}`,
                    {
                        'data': {
                            'id': id,
                            'type': pluralize.singular(this.classConfig().apiResourceName),
                            'attributes': {
                                'blacklist': blacklist
                            }
                        }
                    },
                    options
                )
                .pipe(
                    map((response: HttpResponse<any>) => {
                        return Object.assign({},
                            response.body.data.attributes, { id: response.body.data.id }) as T;
                    })
                );
        };

        target.prototype.whiteList = whiteList;
        target.prototype.blackList = blackList;
        target.prototype.toggleWhiteBlackList = toggleWhiteBlackList;

    };

}
